module.exports = __webpack_public_path__ + "static/buttons@2x-c55cdfe2a44cf29ec31e663d4cfbc199.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/buttons@2x.png
// module id = 2718
// module chunks = 168707334958949